export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'custom_uid';

export const REQUIRED_FIELDS = ['custom_uid'];
